export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const auth0Config = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

export const cognitoConfig = {
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
};

const isLocalhost =
  typeof window !== "undefined" &&
  /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);
console.log(isLocalhost);

// Legge valori runtime da public/env.js, con fallback alle REACT_APP_* o localhost
const RUNTIME = (window && window.__ENV__) || {};

export const API_BASE_URL = (
  (RUNTIME && RUNTIME.API_BASE_URL) ||
  process.env.REACT_APP_API_BASE_URL ||
  "http://localhost:3000"
).replace(/\/$/, "");

export const WS_URL =
  (RUNTIME && RUNTIME.WS_URL) ||
  process.env.REACT_APP_WS_URL ||
  (isLocalhost ? "ws://localhost:7777" : "wss://devops.mobilityexpress.it/ws/");
